// Nine Lives '84 - tick interpolation.
//
// The simulation advances sixty times a second; the display runs at
// whatever the monitor does. Each view keeps the pose from the previous
// tick and the current one, and the renderer blends between them by how
// far through the current tick the frame is.

export interface Pose {
  x: number;
  y: number;
  facing: number;
}

/** Any jump larger than this (respawns, room changes) snaps instead of sliding. */
const SNAP_DISTANCE = 40;

export function lerpPose(prev: Pose, cur: Pose, t: number, out: Pose): Pose {
  const dx = cur.x - prev.x;
  const dy = cur.y - prev.y;
  if (dx * dx + dy * dy > SNAP_DISTANCE * SNAP_DISTANCE) {
    out.x = cur.x;
    out.y = cur.y;
  } else {
    out.x = prev.x + dx * t;
    out.y = prev.y + dy * t;
  }
  out.facing = cur.facing;
  return out;
}
